declare module 'react' {
  namespace JSX {
    interface IntrinsicElements {
      'form-widget': {
        ucid: string;
        mode?: 'popup' | 'form';
        component?: string;
      };
    }
  }
}

interface ViralLoopsFormWidgetProps {
  campaignId: string;
  popup?: boolean;
  customButtonTrigger?: boolean;
}

const ViralLoopsFormWidget = ({ campaignId, popup, customButtonTrigger }: ViralLoopsFormWidgetProps) => {
  if (!campaignId) return null;

  return (
    <form-widget
      ucid={campaignId}
      mode={popup ? 'popup' : 'form'}
      component={customButtonTrigger ? 'customButton' : undefined}
    />
  );
};

export default ViralLoopsFormWidget;
